/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.VisitNoteTypes {
    angular.module("meevo.plugins.visitNoteTypes", []);
}